import { word } from "@modules/core/utils/i18n"
import * as Yup from "yup"

export const creditPurchaseYupValidation = (oldCredit: number | null) =>
  Yup.object({
    newCredits: Yup.number()
      .required(word("global.form.required"))
      .min(-(oldCredit ?? 0), word("box.purchases.modal.credit.formik.error")),
  })
